export default {
  en: {
    agentInformation: 'Information',
    editInformation: 'Edit Information',
    name: 'Name',
    type: 'Type',
    agentTypeName: 'Type Name',
    pleaseSelectAgentType: '-- Please select agent type --',
    otherAgentType: '- Other -',
    market: 'Market',
    newMarket: 'Add Market',
    address: 'Address',
    country: 'Country',
    zipCode: 'Zip Code',
    email: 'Email',
    tel: 'Tel',
    fax: 'Fax',
    changeInformation: 'Change Information',
    addEmail: '+ Add Email',
    addTel: '+ Add Tel.',
    addFax: '+ Add Fax.',
    internalNote: 'Internal Note',
    saveChange: 'Save Changes',
    cancel: 'Cancel',
    saveAgentInfoSuccessTitle: 'Success',
    saveAgentInfoSuccessMessage: 'Update Agent Info Success.',
    confirmRemoveMarketMessage: 'Confirm to remove market?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel'
  },
  th: {
    agentInformation: 'ข้อมูลตัวแทน',
    editInformation: 'แก้ไขข้อมูลตัวแทน',
    name: 'ชื่อ',
    type: 'ประเภท',
    agentTypeName: 'ชื่อประเภท',
    pleaseSelectAgentType: '-- กรุณาเลือกประเภทของตัวแทน --',
    otherAgentType: '- อื่นๆ -',
    market: 'ตลาด',
    newMarket: 'เพิ่มตลาด',
    address: 'ที่อยู่',
    country: 'ประเทศ',
    zipCode: 'รหัสไปรษณีย์',
    email: 'อีเมล',
    tel: 'โทร.',
    fax: 'แฟกซ์',
    changeInformation: 'แก้ไขข้อมูล',
    addEmail: '+ เพิ่มอีเมล',
    addTel: '+ เพิ่มโทร',
    addFax: '+ เพิ่มแฟกซ์',
    internalNote: 'หมายเหตุ',
    saveChange: 'บันทึก',
    cancel: 'ยกเลิก',
    saveAgentInfoSuccessTitle: 'บันทึกสำเร็จ',
    saveAgentInfoSuccessMessage: 'แก้ไขข้อมูลตัวแทนสำเร็จ',
    confirmRemoveMarketMessage: 'กรุณายืนยันการลบตลาด',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก'
  }
}
